import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Container, Card, Table, Button } from 'react-bootstrap'
import toast from 'react-hot-toast'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import Cookies from 'js-cookie'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'


export default function Associatebookingsdetails() {
  const { associateid } = useParams()
  const [bookings, setBookings] = useState([])
  const [loading, setLoading] = useState(true)

  const navigate = useNavigate()
  const location = useLocation()

  const handleBack = () => {
    if (location.state?.from === '/commission') {
      navigate('/commission')
    } else {
      navigate(-1) // Default behavior (go back to the previous page)
    }
  }

  useEffect(() => {
    const fetchBrokerBookings = async () => {
      setLoading(true)

      const token = Cookies.get('authToken') // Retrieve token from cookies

      try {
        const response = await axios.get( BASE_URL,
          `/get/broker/booking?id=${associateid}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          },
        )

        setBookings(response.data.data)
        setLoading(false)
      } catch (error) {
        toast.error('Failed to fetch booking details')
        setLoading(false)
      }
    }
    fetchBrokerBookings()
  }, [associateid])

  if (loading) {
    return <p>Loading associate details...</p>
  }

  return (
    <Container className="pb-3" style={{fontFamily: theme.font.family }}>
          {location.state?.from === '/commission' && (
          <div className="px-3 pb-2 d-flex" 
              onClick={handleBack}
              style={{ cursor: 'pointer' , color: theme.colors.secondary, alignItems: 'center', backgroundColor:theme.colors.background }}
          
          >

              <i
                className="fa fa-arrow-left"
                style={{ fontSize: '1rem', marginRight: '8px' }}
              ></i>
              <span>Back to Associate Commission</span>
           
          </div>
        )}
      
 <div className='px-3 mb-3' style={{ backgroundColor: theme.colors.background }}>



  <p className="mb-4 fw-bold" style={{ color: theme.colors.primary, borderBottom: `2px solid ${theme.colors.secondary}`, paddingBottom: '8px' , fontSize: '1.5rem'}}>Associate's Bookings</p>


        




 {/* </div> */}

      
        {/* <div className='px-3 mb-3' style={{ backgroundColor: theme.colors.background }}> */}

          <Table
            bordered
            hover
            responsive="md"
            className="text-center  table table-bordered table-hover"
          >
            <thead className="position-sticky top-0  text-start table-success">
<tr className="text-start">
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Booking ID</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Plot Number</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Site Name</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Booking Date</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Actual Amount</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Discount Amount</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }} title="Selling Amount">Final Amount</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Booking Amount</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Booking Payment Status</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Booking Status</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Due Date</th>
</tr>

            </thead>

            <tbody className="text-start">
              {Array.isArray(bookings) && bookings.length > 0 ? (
                bookings.map((booking) => (
                  <tr key={booking.id}>
                    <td style={{ cursor: 'pointer' }}>
                      <Link to={`/BookedDetailpage/${booking.id}`}>
                        {booking.id}
                      </Link>
                    </td>
                    <td>{booking?.plot_details?.[0]?.plot_number}</td>
                    <td>{booking?.plot_details?.[0]?.site_name}</td>
                    <td>
                      {new Date(booking.booking_date).toLocaleDateString(
                        'en-GB',
                        {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric',
                        },
                      )}
                    </td>
                    <td>{`₹ ${(
                      booking.actual_price || 0
                    ).toLocaleString()}`}</td>
                    <td>{`₹ ${(
                      booking.discount_price || 0
                    ).toLocaleString()}`}</td>
                    <td title="Selling Amount">{`₹ ${(
                      booking.final_price || 0
                    ).toLocaleString()}`}</td>
                    <td>{`₹ ${(
                      booking.booking_price || 0
                    ).toLocaleString()}`}</td>
                    <td>{booking.booking_payment_status}</td>
                    <td>{booking.booking_status}</td>
                    <td>
                      {booking.due_date
                        ? new Date(booking.due_date).toLocaleDateString(
                            'en-GB',
                            {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric',
                            },
                          )
                        : 'N/A'}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="text-center" colSpan={11}>
                    No bookings found for this associate.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
           </div>
    </Container>
  )
}
